import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/Header";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function LoginPage() {
  const { login } = useAuth() || {};
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const u = await login(email, pwd);
      const redirect = location.state?.redirect || (u.is_admin ? "/admin" : "/dashboard");
      navigate(redirect);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  const onGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-lokaso-sand flex items-center justify-center px-4 py-16" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo /></div>
        <div className="bg-white rounded-2xl border border-stone-200 shadow-lg p-8">
          <h1 className="font-display text-3xl font-bold text-center">Bon retour</h1>
          <p className="text-center text-stone-600 mt-1">Connectez-vous à votre compte Lokaso</p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs uppercase tracking-wider font-semibold text-stone-500">Email</label>
              <input
                type="email" required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full h-12 px-4 rounded-xl border border-stone-200 focus:outline-none focus:ring-2 focus:ring-lokaso-green"
                placeholder="vous@exemple.gn"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider font-semibold text-stone-500">Mot de passe</label>
              <input
                type="password" required
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                className="mt-1 w-full h-12 px-4 rounded-xl border border-stone-200 focus:outline-none focus:ring-2 focus:ring-lokaso-green"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>
            {err && <p className="text-sm text-lokaso-red" data-testid="login-error">{err}</p>}
            <button type="submit" disabled={loading} className="btn-green w-full" data-testid="login-submit-btn">
              {loading ? "Connexion…" : "Se connecter"}
            </button>
          </form>

          <div className="flex items-center gap-3 my-6">
            <div className="flex-1 h-px bg-stone-200" />
            <span className="text-xs text-stone-500">ou</span>
            <div className="flex-1 h-px bg-stone-200" />
          </div>

          <button onClick={onGoogle} className="w-full h-12 rounded-xl border border-stone-200 hover:bg-stone-50 font-medium inline-flex items-center justify-center gap-2" data-testid="login-google-btn">
            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.5-5.9 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.8 6.4 29.7 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3l5.7-5.7C34.8 6.4 29.7 4 24 4 16.3 4 9.6 8.4 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.6 0 10.6-2.1 14.4-5.6l-6.6-5.6c-2 1.5-4.6 2.4-7.8 2.4-5.4 0-9.7-3.5-11.3-8.3l-6.6 5.1C9.4 39.5 16.1 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.7l6.6 5.6c-.6.6 7.1-5.2 7.1-15.3 0-1.3-.1-2.4-.4-3.5z"/></svg>
            Continuer avec Google
          </button>

          <p className="mt-6 text-sm text-center text-stone-600">
            Pas de compte ?{" "}
            <Link to="/register" className="text-lokaso-red font-semibold hover:underline" data-testid="login-register-link">Créer un compte</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
